import { render, staticRenderFns } from "./AdquisicionPedidosServicios.vue?vue&type=template&id=0863d814&scoped=true"
import script from "./AdquisicionPedidosServicios.vue?vue&type=script&lang=js"
export * from "./AdquisicionPedidosServicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0863d814",
  null
  
)

export default component.exports